export const stringsKey = "PickLanguageWidget";
export const englishStrings = {
	messageText: "Message Text",
	audioFile: "Audio File",
	timeout: "Timeout",
	maxRetries: "Max Retries",
	retryMessageText: "Retry Message Text",
	retryAudioFile: "Retry Audio File",
	messageTextErrorMessage: "The message text field is required.",
	timeoutErrorMessage: "The timeout field is required.",
};
